import React, { useContext, useEffect, useRef } from 'react';
import { TAB_NAVIGATION_IDS } from './constants';
import { TabsNavigationContext } from './context';
import { useTabsIntersecting } from './useIntersecting';

import './TabNavigationSection.scss';

export const TabNavigationSection: React.FC<{
    tabNavigationId: TAB_NAVIGATION_IDS;
}> = ({ children, tabNavigationId }) => {
    const lazyElement = useRef(null);
    const { setIsTabIntersecting } = useContext(TabsNavigationContext);
    const [isIntersecting] = useTabsIntersecting({
        ref: lazyElement,
    });

    useEffect(() => {
        setIsTabIntersecting(tabNavigationId, isIntersecting);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isIntersecting, tabNavigationId]);

    return (
        <div
            id={tabNavigationId}
            className="tab-navigation-section"
            ref={lazyElement}
        >
            {children}
        </div>
    );
};
